// src/firebaseConfig.js — Admin app (with App Check, CRA/Vite compatible)
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: 'AIzaSyDmNKd0HuVLzQ5pRt0n8h9Sg6g5FgWQlfc',
  authDomain: 'aug-fixihub.firebaseapp.com',
  projectId: 'aug-fixihub',
  storageBucket: 'aug-fixihub.firebasestorage.app',
  messagingSenderId: '891015716321',
  appId: '1:891015716321:web:9ff18f6ea6c0264af886a0',
  measurementId: 'G-FCRFVJD0Y8',
};

const app = initializeApp(firebaseConfig);

// Resolve site key from either Vite or CRA envs
const SITE_KEY =
  (typeof import.meta !== 'undefined' &&
    import.meta.env &&
    import.meta.env.VITE_RECAPTCHA_SITE_KEY) ||
  process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
  '';

// Your manually registered debug token
const debugToken = '82DBE730-807C-42D3-81FA-72A1D95E1A1B';

/* ----------------------------- App Check ----------------------------- */
if (typeof window !== 'undefined' && SITE_KEY) {
  // Use a debug token for local development
  if (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  ) {
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
  }

  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'europe-west2');